import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Bubble } from 'tea-component';
import GameImage from '@/pages/home/components/GameImage';
// import SvgIcon from '@/pages/home/components/SvgIcon';

import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IMobileStoreRankTopGlobalCompareRankGame } from '@/pages/intelligence/types/storeRank';

import './index.scss';

interface ICompareGameBoxProps extends IBaseProps {
  isActive: boolean;
  isShowTopInfo: boolean;
  data: IMobileStoreRankTopGlobalCompareRankGame;
  onMouseEnter: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave: React.MouseEventHandler<HTMLDivElement>;
  onClick?: (e: React.SyntheticEvent<HTMLDivElement>) => void;
}

const CompareGameBox: React.FC<ICompareGameBoxProps> = (props) => {
  const { isActive = false, isShowTopInfo = false, data, onMouseEnter, onMouseLeave, onClick } = props;

  const { formatMessage } = useIntl();

  const { name, cover, genre, publisher, top_20_cnt: top20Cnt } = data ?? {};

  const handleClick = (e: React.SyntheticEvent<HTMLDivElement>) => {
    onClick?.(e);
  };

  if (!data)
    return (
      <div style={{ cursor: 'initial' }}>
        <span style={{ fontSize: 12 }}>-</span>
      </div>
    );

  return (
    <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={handleClick}>
      <Bubble
        className="dbi-compare-gamebox-bubble"
        content={
          <div className="dbi-mobile-store-rank-global-compare-game-tips-container">
            <h3>{name}</h3>
            <p>
              {formatMessage({ id: 'dbi_publisher' })}: {publisher}
            </p>
            <p>
              {formatMessage({ id: 'dbi_label_genre' })}: {genre}
            </p>
            {isShowTopInfo && (
              <p>
                {formatMessage({ id: 'dbi_store_rank_mobile_global_compare_top_20_countries_tips' }, { num: top20Cnt })}
              </p>
            )}
          </div>
        }
        dark
      >
        <div className={classnames('dbi-compare-gamebox', { active: isActive })}>
          <GameImage className="dbi-compare-gamebox-img" entityType="mobile" src={cover} />
          <span className="dbi-compare-gamebox-text">{name}</span>
        </div>
      </Bubble>
    </div>
  );
};

export default CompareGameBox;
